// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 3: イエス・キリスト
// ============================================================================
// レベル 27-39 (13レベル、39問)

export const chapter3Translations = {
  name: 'イエス・キリスト',
  description: '言は肉となった... キリストを知ることは永遠の命',
  
  spiritualWisdom: {
    principle: 'イエス・キリストを知ることは永遠の命',
    scripture: '永遠の命とは、唯一のまことの神であるあなたと、あなたが遣わされたイエス・キリストを知ることです (ヨハネ17:3)',
    application: 'イエスの生涯のあらゆる側面が神を啓示し、永遠のために私たちの魂を養う'
  },
  
  levels: {
    27: {
      name: '受胎告知',
      challenge: '天使ガブリエルが神から遣わされてガリラヤの町に...',
      easy: {
        question: 'マリアにイエスを身ごもることを告げたのはどの天使ですか?',
        options: ['ミカエル', 'ガブリエル', 'ラファエル', 'ウリエル'],
        hint: '神の使いの天使',
        funFact: '👼 ガブリエルは神の力という意味 - 偉大な告知の天使!'
      },
      medium: {
        question: 'この告知に対するマリアの最初の反応は何でしたか?',
        options: [
          '即座の喜び',
          '完全な不信',
          '困惑とどうしてそのようなことがあり得ましょうかという質問',
          '恐れ'
        ],
        hint: '実用的で正当な質問',
        funFact: '🤔 マリアは論理的な質問をするが、神に対して心を開いている!'
      },
      hard: {
        question: 'マリアの神の御心への服従は何を教えてくれますか?',
        options: [
          '試練の前での受動性',
          'すべてを理解しなくても信頼する信仰',
          '盲目的な従順',
          '諦め'
        ],
        hint: '未知のことでも神を信頼することについて',
        funFact: '🙏 お言葉どおりこの身になりますように - 信頼する信仰の模範!'
      }
    },
    
    28: {
      name: '降誕',
      challenge: '初子である男の子を産み、布にくるんで飼い葉桶に寝かせた...',
      easy: {
        question: 'イエスはどの町で生まれましたか?',
        options: ['ナザレ', 'エルサレム', 'ベツレヘム', 'カペナウム'],
        hint: 'ダビデの町',
        funFact: '🏘️ ベツレヘムはパンの家という意味 - イエス、命のパン!'
      },
      medium: {
        question: '誕生の知らせを最初に受けたのは誰ですか?',
        options: [
          '博士たち',
          '野原の羊飼いたち',
          '神殿の祭司たち',
          'マリアの家族'
        ],
        hint: '羊の群れを守っていた単純な人々',
        funFact: '🐑 神はまず謙虚な羊飼いたちに告げる - すべての人への福音!'
      },
      hard: {
        question: '飼い葉桶に生まれたイエスは何を象徴していますか?',
        options: [
          '両親の貧しさ',
          '私たちのところまで身を低くする神の謙遜',
          '場所の不足',
          '田舎の素朴さ'
        ],
        hint: '謙遜における神の受肉について',
        funFact: '👶 宇宙の創造主が馬小屋で生まれる - 無限の愛!'
      }
    },

    29: {
      name: '東方の博士たち',
      challenge: '東方から博士たちがエルサレムに来て尋ねた...',
      easy: {
        question: '博士たちをイエスのところに導いたものは何ですか?',
        options: ['天使', '星', '幻', '地図'],
        hint: '空の天体',
        funFact: '⭐ 星はイエスが諸国民の光であることを表す!'
      },
      medium: {
        question: '博士たちはどんな贈り物をしましたか?',
        options: [
          '食べ物',
          '黄金、乳香、没薬',
          '貴重な衣服',
          'おもちゃ'
        ],
        hint: '象徴的で貴重な三つの贈り物',
        funFact: '🎁 黄金(王権)、乳香(神性)、没薬(犠牲) - イエスの全使命!'
      },
      hard: {
        question: 'これらの異邦人の博士たちは神の計画において何を表していますか?',
        options: [
          '他の宗教の優位性',
          'すべての民に提供される救いの普遍性',
          '物質的な富',
          '古代科学'
        ],
        hint: 'すべての国々への救いの開放について',
        funFact: '🌍 博士たちは全世界に届く福音を予告している!'
      }
    },

    30: {
      name: 'イエスの洗礼',
      challenge: 'イエスが洗礼を受けられると、すぐに水から上がられた...',
      easy: {
        question: 'イエスに洗礼を授けたのは誰ですか?',
        options: ['ペトロ', '洗礼者ヨハネ', 'アンデレ', 'ヤコブ'],
        hint: 'イエスの先駆者',
        funFact: '🌊 洗礼者ヨハネはイエスの履物のひもを解く値打ちもないと考えた!'
      },
      medium: {
        question: '洗礼の時イエスの上に降ったものは何ですか?',
        options: [
          '光',
          '鳩(聖霊)',
          '天使',
          '声だけ'
        ],
        hint: '平和の象徴である鳥',
        funFact: '🕊️ 鳩は宣教を始めるための神の油注ぎを示す!'
      },
      hard: {
        question: '罪のないイエスがなぜ洗礼を受けたのですか?',
        options: [
          '模範を示すため',
          'すべての正しさを実現し、私たちと一体となるため',
          '宗教的義務のため',
          '赦しを受けるため'
        ],
        hint: '罪深い人類との連帯について',
        funFact: '❤️ イエスは私たちをより良く救うため、完全に私たちと一体となる!'
      }
    },

    31: {
      name: '荒れ野の誘惑',
      challenge: 'イエスは悪魔から誘惑を受けるため、霊によって荒れ野に導かれた...',
      easy: {
        question: 'イエスは荒れ野でどのくらい断食しましたか?',
        options: ['30日', '40日', '50日', '60日'],
        hint: '試練の聖書的数字',
        funFact: '🏜️ モーセとエリヤのように、40日間の集中的な霊的準備!'
      },
      medium: {
        question: 'イエスはどのように各誘惑を退けましたか?',
        options: [
          '自分の力で',
          '聖書を引用して',
          'サタンを無視して',
          '祈りだけで'
        ],
        hint: '卓越した霊的武器',
        funFact: '📖 書いてある... - 神の言葉、霊の剣!'
      },
      hard: {
        question: 'イエスの誘惑は私たちの戦いについて何を教えてくれますか?',
        options: [
          '誘惑は罪である',
          '誘惑は御言葉と信仰によって克服できる',
          'すべての荒れ野から逃げなければならない',
          'イエスだけが抵抗できる'
        ],
        hint: '誘惑に対する私たちの戦略について',
        funFact: '⚔️ イエスは勝利の方法を示す:神の言葉+能動的信仰!'
      }
    },

    32: {
      name: '最初の弟子たち',
      challenge: 'イエスは言われた:わたしについて来なさい。人間をとる漁師にしよう...',
      easy: {
        question: 'ペトロとアンデレの職業は何でしたか?',
        options: ['羊飼い', '漁師', '大工', '徴税人'],
        hint: 'ガリラヤ湖での職業',
        funFact: '🎣 イエスは魚を捕る漁師を魂を捕る漁師に変える!'
      },
      medium: {
        question: '最初の弟子たちは召命にどう反応しましたか?',
        options: [
          '長い間ためらった',
          '証拠を求めた',
          'すべてを捨ててすぐに従った',
          '交渉した'
        ],
        hint: '即座で完全な応答',
        funFact: '🚶 イエスの権威は明白で、すぐに従った!'
      },
      hard: {
        question: '現代においてイエスに従うとはどういう意味ですか?',
        options: [
          '仕事を辞めること',
          'イエスの教えと御心に従って生きること',
          '孤立したコミュニティに加わること',
          '宣教だけすること'
        ],
        hint: '人生と優先順位の変革について',
        funFact: '✨ イエスに従うことは心、選択、運命を変える!'
      }
    },

    33: {
      name: '山上の垂訓',
      challenge: '心の貧しい者は幸いです。天の御国はその人たちのものだからです...',
      easy: {
        question: '山上の垂訓の最初の幸いは何ですか?',
        options: [
          '心のきよい者は幸いです',
          '心の貧しい者は幸いです',
          '柔和な者は幸いです',
          '平和をつくる者は幸いです'
        ],
        hint: '霊的な謙遜に関するもの',
        funFact: '😊 心の貧しい者は神を必要としていることを知っています - 御国への門!'
      },
      medium: {
        question: '平和をつくる者についてイエスは何と言いましたか?',
        options: [
          '幸運になるでしょう',
          '神の子どもと呼ばれます',
          '愛されるでしょう',
          '力強くなるでしょう'
        ],
        hint: '特別な神的アイデンティティ',
        funFact: '👑 平和をつくる者は神に似ています - 神の性質の生きた証し!'
      },
      hard: {
        question: '幸いの教えは世の価値観をどのように逆転させますか?',
        options: [
          '富を非難することによって',
          '信者を孤立させることによって',
          '世が軽蔑する者を祝福すると宣言することによって',
          '律法を廃止することによって'
        ],
        hint: '世俗的な価値観に反する神の価値観について',
        funFact: '🔄 幸いの教えは幸福と成功の見方を変えます!'
      }
    },

    34: {
      name: '御国のたとえ',
      challenge: 'イエスは多くのことをたとえで教えられた...',
      easy: {
        question: '種まきのたとえで、種は何を表していますか?',
        options: [
          'お金',
          '神のことば',
          '善行',
          '愛'
        ],
        hint: 'イエスが宣べ伝え、教えられるもの',
        funFact: '🌱 神のことばは私たちの心の中で芽生え、成長します!'
      },
      medium: {
        question: 'からし種のたとえで、この小さな種は何を象徴していますか?',
        options: [
          '人間の弱さ',
          '小さく始まるが大きく成長する御国',
          '細部の重要性',
          '自然'
        ],
        hint: '印象的に成長するもの',
        funFact: '🌳 最も小さい種から大きな木が生まれる - 御国の力!'
      },
      hard: {
        question: 'なぜイエスはたとえで教えられたのですか?',
        options: [
          'メッセージを複雑にするため',
          '身近なイメージを通して霊的真理を明らかにするため',
          '時間がなかったため',
          '知性を試すため'
        ],
        hint: '御国の奥義を理解しやすくすることについて',
        funFact: '💡 たとえは開かれた心には明らかにし、閉ざされた心には隠します!'
      }
    },

    35: {
      name: 'イエスの奇跡',
      challenge: 'イエスは嵐を静め、海に言われた:静まれ、黙れ!...',
      easy: {
        question: 'イエスは何個のパンで5000人に食べ物を与えましたか?',
        options: ['3個のパン', '5個のパン', '7個のパン', '12個のパン'],
        hint: '魚と同じ数',
        funFact: '🍞 5つのパンと2匹の魚が祝宴になる - 神の寛大さ!'
      },
      medium: {
        question: 'イエスが嵐を静めたとき、弟子たちは何と言いましたか?',
        options: [
          '魔法使いだ',
          '風も海も従うこの方はどなたなのだろう?',
          '普通のことだ',
          'ここから去るべきだ'
        ],
        hint: 'イエスのアイデンティティについての質問',
        funFact: '⛈️ 自然の要素でさえ創造主であり主である方を認めます!'
      },
      hard: {
        question: 'イエスの奇跡の主な目的は何ですか?',
        options: [
          '群衆を感動させること',
          '神性を明らかにし、神の愛を示すこと',
          '影響力を得ること',
          '物質的に助けるだけ'
        ],
        hint: '神の啓示と憐れみについて',
        funFact: '❤️ すべての奇跡は神の心を明らかにします:愛、憐れみ、力!'
      }
    },

    36: {
      name: '変貌',
      challenge: 'イエスは彼らの前で姿が変わり、顔は太陽のように輝いた...',
      easy: {
        question: 'どの弟子たちがイエスの変貌を見ましたか?',
        options: [
          '十二人全員',
          'ペテロ、ヤコブ、ヨハネ',
          'ペテロとヨハネだけ',
          'イエスに従った女性たち'
        ],
        hint: '三人の内側の輪',
        funFact: '⛰️ ペテロ、ヤコブ、ヨハネ:神の栄光の特権的な証人!'
      },
      medium: {
        question: '旧約聖書のどの人物が現れましたか?',
        options: [
          'アブラハムとイサク',
          'ダビデとソロモン',
          'モーセとエリヤ',
          'アダムとノア'
        ],
        hint: '律法の代表者と預言者の代表者',
        funFact: '📜 モーセ(律法)とエリヤ(預言者)がイエスを証しします!'
      },
      hard: {
        question: 'この変貌はイエスの性質について何を明らかにしますか?',
        options: [
          '偉大な預言者である',
          '隠された神性が一時的に明らかになる',
          '光を支配できる',
          '姿を変えられる'
        ],
        hint: '神の性質の啓示について',
        funFact: '✨ イエスの神の栄光が輝く - 復活の予告!'
      }
    },

    37: {
      name: '凱旋入城',
      challenge: 'ホサナ、ダビデの子に!主の御名によって来られる方に祝福あれ!...',
      easy: {
        question: 'イエスはどの動物に乗ってエルサレムに入りましたか?',
        options: ['馬', 'ろば', 'らくだ', '徒歩'],
        hint: '謙遜と平和の象徴の動物',
        funFact: '🐴 ろばは戦争ではなく平和のうちに来る謙遜な王を象徴します!'
      },
      medium: {
        question: 'イエスを迎える群衆は何と叫びましたか?',
        options: [
          '王万歳!',
          'ホサナ!主の御名によって来られる方に祝福あれ!',
          '神に栄光あれ!',
          '自由を!'
        ],
        hint: '喜びと祝福の叫び',
        funFact: '🌿 「ホサナ」は「今、救ってください」という意味 - 神の救いへの呼びかけ!'
      },
      hard: {
        question: 'なぜこの入城は「凱旋」なのに悲劇的なのですか?',
        options: [
          '人が少なかった',
          '歓迎する群衆が5日後に拒絶する',
          '当局が不在だった',
          '雨が降っていた'
        ],
        hint: '人間の心の移り気について',
        funFact: '💔 同じ群衆が数日後に「十字架につけろ!」と叫びます!'
      }
    },

    38: {
      name: '最後の晩餐',
      challenge: '取って食べなさい。これはあなたがたのために与えるわたしのからだです...',
      easy: {
        question: 'イエスは弟子たちの足に何をしましたか?',
        options: [
          '祝福した',
          '洗った',
          '香油を塗った',
          '口づけした'
        ],
        hint: '謙遜と奉仕の行為',
        funFact: '🦶 師が僕になる - 愛と謙遜の革命!'
      },
      medium: {
        question: 'この晩餐でイエスは何を制定しましたか?',
        options: [
          'バプテスマ',
          '聖餐式',
          '主の祈り',
          '断食'
        ],
        hint: 'パンとぶどう酒を用いる聖礼典',
        funFact: '🍞🍷 パンとぶどう酒は犠牲と愛の永遠のシンボルになります!'
      },
      hard: {
        question: '「わたしを覚えてこれを行いなさい」とはどういう意味ですか?',
        options: [
          'この晩餐を繰り返す',
          'わたしが戻るまで、わたしの死と復活を祝う',
          'わたしのことばを覚える',
          '互いに愛し合う'
        ],
        hint: '生きた預言的な記念について',
        funFact: '⏳ すべての聖餐式は主が来られるまで主の死を告げ知らせます!'
      }
    },

    39: {
      name: 'ゲツセマネ',
      challenge: '父よ、できることなら、この杯をわたしから過ぎ去らせてください...',
      easy: {
        question: 'イエスは逮捕される前にどこで祈りましたか?',
        options: [
          '神殿で',
          'ゲツセマネの園で',
          'オリーブ山で',
          '友人の家で'
        ],
        hint: 'オリーブの木の園',
        funFact: '🫒 ゲツセマネは「油搾り」を意味する - 激しい圧力の場所!'
      },
      medium: {
        question: 'イエスが祈っている間、弟子たちは何をしましたか?',
        options: [
          '一緒に祈った',
          '眠ってしまった',
          '見張りをした',
          '去って行った'
        ],
        hint: '一時間も目を覚ましていられなかった',
        funFact: '😴 心は燃えていても肉体は弱い - 人間の弱さ!'
      },
      hard: {
        question: 'イエスの苦悶は何を明らかにしますか?',
        options: [
          '単なる人間だった',
          '完全に人間であり完全に神である',
          '使命を疑っていた',
          '弱かった'
        ],
        hint: '受肉の神秘について',
        funFact: '✝️ イエスは神に忠実であり続けながら、人間の苦悩を完全に負われます!'
      }
    }
  }
};

export default chapter3Translations;
